import { AxiosResponseHeaders } from 'axios';
import { MakeTransferResponseDTO } from '../entities';

const makeTransferDTOToMakeTransferAdapter = (data: MakeTransferResponseDTO, headers?: AxiosResponseHeaders) => {
  if (!data.body) {
    throw new Error('Error');
  }

  return data.body;
};

export { makeTransferDTOToMakeTransferAdapter };
